/**
 * Web Style Import
 *
 */

import './style/dnb-textarea.scss'
